/** Indent per level. Enough to read as nesting without pushing a deep row off the rail. */
export const RAIL_INDENT_PX = 12;

/** The left padding a rail row carries at the root, which an indent is added to. */
const RAIL_ROW_PADDING_PX = 12;

/**
 * Left padding for a row nested `depth` levels in.
 *
 * Added to the row's own padding rather than replacing it, so it stays in step with the `px-sm` in
 * {@link railRowClass}.
 */
export const railRowIndent = (depth: number) => RAIL_ROW_PADDING_PX + depth * RAIL_INDENT_PX;

/**
 * How one row of a library rail reads, chosen or not.
 *
 * A function shared by the rails rather than a class copied into each: the folders and the tags
 * are two lists of the same kind of thing, sitting in the same column, and a person moving between
 * them should not be able to tell they were built apart. The fill runs past the text on both, which
 * is why the padding belongs to the row and not to what it holds.
 *
 * The chosen and hover fills are `NavigationPanel`'s, so this rail reads like the knowledge files
 * panel.
 */
export const railRowClass = (active: boolean) =>
  `flex w-full items-center gap-xs rounded-lg px-sm py-xs text-left text-body-md transition-colors duration-fast ease-out ${
    active ? 'bg-accent font-medium text-foreground' : 'text-sidebar-foreground hover:bg-surface'
  }`;

/**
 * A row's count, quieter than its name. On the chosen row it takes the name's colour, because
 * `text-foreground-alt` on `bg-accent` falls below 4.5:1.
 */
export const railRowCountClass = (active: boolean) =>
  `flex-1 tabular-nums ${active ? 'text-foreground' : 'text-foreground-alt'}`;
